import React from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';

import { Heading } from '@amzn/storm-ui';

import QueueSheetManagement from '../QueueSheetManagement/QueueSheetManagement';

const AdSlotManagement: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div id="adslot-management-container">
      <Heading id="adslot-management-header" size="medium">
        {t('adslot-management-header')}
      </Heading>
      <QueueSheetManagement />
      <Outlet />
    </div>
  );
};

export default AdSlotManagement;
